import { AccountInfo, PublicClientApplication } from '@azure/msal-browser';
import axios from 'axios';
import { loginRequest, msalConfig } from '../authConfig';

const API_SERVER_URL = import.meta.env.VITE_API_URL;
export const msalInstance = new PublicClientApplication(msalConfig);


const getAccount = async (): Promise<AccountInfo | undefined> => {
  await msalInstance.initialize();
  const accounts = msalInstance.getAllAccounts();
  return accounts?.[0];
}

const getAccessToken = async (): Promise<string | undefined> => {
  const account = await getAccount();
  if (!account) {
    return;
  }

  const accessTokenResponse = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account
  })

  return `Bearer ${accessTokenResponse.accessToken}`;
}

export const signOut = async () => {
  const account = await getAccount();
  if (!account) {
    return;
  }
  await msalInstance.logoutRedirect({
    account,
    postLogoutRedirectUri: '/signout',
  });
}

axios.interceptors.request.use(async (config) => {
  config.headers.Authorization = await getAccessToken();
  return config;
})

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/';
    } else if (error.response && error.response.status === 403) {
      window.location.href = "/signout";
    }
    return Promise.reject(error);
  }
)


/**
 * Gets the API data from the server.
 * @param url - the url to get the data from.
 */
export const getApi = (url: string, config?: any) => axios.get(API_SERVER_URL + url, config);

/**
 * posts data to the API Server (this is for llm api).
 * @param url - the url to post to.
 * @param data - the data to post.
 * @param shortUrl - whether or not to use the short url.
 */

/**
 * Posts data to the API server.
 * @param url - the url to post to.
 * @param data - the data to post.
 * @param shortUrl - whether or not to use the short url.
 */
export const postApi = (url: string, data?: any, config?: any, shortUrl: boolean = true) =>
  axios.post((shortUrl ? API_SERVER_URL : '') + url, data, config);

/**
 * Sends a PUT request to the API server.
 * @param url - the url to upadte.
 * @param data - the data to update.
 * @param shortUrl - whether or not to use the short url.
 */
export const putApi = (url: string, data?: any, config?: any, shortUrl: boolean = true) =>
  axios.put((shortUrl ? API_SERVER_URL : '') + url, data, config);

/**
 * Deletes the given url from the API server.
 * @param url - the url to delete from the API server.
 */
export const deleteApi = (url: string) => axios.delete(API_SERVER_URL + url);
